import React from 'react';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { ServiceRequest, RequestStatus } from '../utils/mockData';
import { CATEGORIES } from '../utils/constants';
interface RequestCardProps {
  request: ServiceRequest;
}
const getStatusColor = (status: RequestStatus) => {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'in-progress':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'completed':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'cancelled':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getStatusLabel = (status: RequestStatus) => {
  switch (status) {
    case 'in-progress':
      return 'In Progress';
    default:
      return status.charAt(0).toUpperCase() + status.slice(1);
  }
};
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-MY', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: 'numeric'
  }).format(date);
};
export function RequestCard({
  request
}: RequestCardProps) {
  const category = CATEGORIES.find(c => c.id === request.categoryId);
  const Icon = category?.icon || Clock;
  return <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col gap-3" data-id="element-76">
      <div className="flex justify-between items-start" data-id="element-77">
        <div className="flex items-center gap-3" data-id="element-78">
          <div className="bg-teal-50 p-2 rounded-lg text-teal-600" data-id="element-79">
            <Icon className="w-5 h-5" data-id="element-80" />
          </div>
          <div data-id="element-81">
            <h4 className="font-semibold text-gray-900 text-sm" data-id="element-82">
              {request.categoryName}
            </h4>
            <span className="text-xs text-gray-400 font-mono" data-id="element-83">
              {request.id}
            </span>
          </div>
        </div>
        <span className={`text-xs font-medium px-2.5 py-1 rounded-full border ${getStatusColor(request.status)}`} data-id="element-84">
          {getStatusLabel(request.status)}
        </span>
      </div>

      <p className="text-sm text-gray-600 line-clamp-2 min-h-[2.5rem]" data-id="element-85">
        {request.issue}
      </p>

      <div className="flex items-center justify-between text-xs text-gray-400 pt-3 border-t border-gray-50 mt-1" data-id="element-86">
        <div className="flex items-center gap-1" data-id="element-87">
          <Calendar className="w-3.5 h-3.5" data-id="element-88" />
          <span data-id="element-89">{formatDate(request.date)}</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-90">
          <MapPin className="w-3.5 h-3.5" data-id="element-91" />
          <span data-id="element-92">{request.location}</span>
        </div>
      </div>
    </div>;
}